<script>
    import GeneralHeaderBar from "../../../common/header/GeneralHeaderBar.svelte";
    import BackButton from "../../../common/buttons/BackButton.svelte";
    import InfoIconButton from "../../../common/buttons/InfoIconButton.svelte";
    import { createEventDispatcher } from "svelte";

    export let title;
    export let showTitleAlways = true;
    export let hideSeperator;
    export let info;
    export let onSite = false;

    $: if (info) console.log("info: ", info);

    let dispatch = createEventDispatcher();
</script>

<GeneralHeaderBar {title} {showTitleAlways} {hideSeperator} {onSite}>
    <div slot="pre-title">
        <BackButton />
    </div>
    <div slot="post-title" style="overflow: hidden;" class="info-button">
        {#if info}
            <InfoIconButton on:click={() => dispatch("actionClicked")} />
        {/if}
    </div>
</GeneralHeaderBar>

<style>
    @media (min-width: 1440px) {
        .info-button {
            display: none;
        }
    }
</style>
